export default "__VITE_ASSET__da329b70__"